

<div *ngIf="fv" style="height: fit-content;">

    <form [formGroup]="fv.form" class="form-work-area">

        <formly-form [form]="fv.form" [fields]="fv.fields" [model]="fv.model" [options]="fv.options">
        </formly-form>

    </form>

</div>